import ErrorDisplay from "../../../components/error-display";
import Header from "../../../components/header";
import Loading from "../../../components/loading";
import SaveComplete from "../../../components/save-complete";
import Saving from "../../../components/saving";
import EditRuleActions from "./components/edit-rule-actions";
import EditRuleForm from "./components/edit-rule-form";
import useEditRule, { EditRuleState } from "./hooks/use-edit-rule";

export default function EditRule() {
  const editRuleState: EditRuleState = useEditRule();

  return (
    <form
      className="flex flex-col flex-grow"
      onSubmit={editRuleState.handleSubmit(editRuleState.doSubmit)}
    >
      <div className="flex flex-col flex-grow w-full">
        <Header>
          <div className="py-6 text-3xl font-semibold text-white">
            Edit Rule
          </div>
        </Header>
        {editRuleState.errorMessage && (
          <ErrorDisplay
            message={editRuleState.errorMessage}
            onClick={editRuleState.clearError}
          />
        )}
        {editRuleState.saving && (
          <div className="absolute inset-0 flex flex-col h-full">
            <Saving />
          </div>
        )}
        {editRuleState.saveComplete && (
          <div className="absolute inset-0 flex flex-col h-full">
            <SaveComplete />
          </div>
        )}
        {editRuleState.loading && <Loading />}
        {!editRuleState.loading && editRuleState.rule && (
          <div className="container flex flex-col items-center mx-auto md:px-36">
            <EditRuleForm state={editRuleState} />
            <EditRuleActions state={editRuleState} />
          </div>
        )}
      </div>
    </form>
  );
}
